import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Connects to data-controller="multiupload"
export default class extends Controller {
  connect() {
    console.warn("DISABLED Connecting Multiupload controller");
  }
  
  
  prevent_connect() {
    console.debug("Connecting Multiupload controller");
    
    const root = this.element;
    const fileInputField = root.querySelector('input[type="file"]');
    const url = fileInputField.dataset.directUploadUrl;
    const name = fileInputField.name;

    this.root = root;
    this.fileInputField = fileInputField;
    this.url = url;
    this.name = name;

    this.fileInputField.addEventListener("change", (event) => {
      console.debug("File input change event", event);
      event.preventDefault();
      const files = event.target.files;
      Array.from(files).forEach(file => this.uploadFile(file, url, name))
    });
  }

  uploadFile(file, url, name) {
    const upload = new DirectUpload(file, url, this);

    upload.create((error, blob) => {
      if (error) {
        // Handle the error
      } else {
        // Add an appropriately-named hidden input to the form
        // with a value of blob.signed_id
        const hiddenField = document.createElement('input');
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("value", blob.signed_id);
        hiddenField.name = name;

        this.element.appendChild(hiddenField);
      }
    })
  }

  directUploadWillStoreFileWithXHR(request) {
    console.debug("Direct upload will store file with XHR", request);

    request.upload.addEventListener("progress", event => this.directUploadDidProgress(event))
    request.upload.addEventListener("load", event => {
      console.debug("Direct upload START load", event)
      this.fileInputField.value = ""
    })
  }

  directUploadDidProgress(event) {
    console.debug("Direct upload progress", event);
    // Use event.loaded and event.total to update the progress bar
  }
}
